<template>
  <div class="content">
    <el-row type="flex" justify="start">
      <el-col :span="12">
        <el-form
          label-position="left"
          label-width="180px"
          ref="form"
          :rules="rules"
          :model="form"
        >
          <h3>奖励金设置</h3>
          <el-form-item
            label="零售单品结算时长（天）"
            prop="retail_item_settlement_time"
          >
            <el-input
              v-model="form.retail_item_settlement_time"
              placeholder="请输入正整数"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="VIP 套组结算时长（天）"
            prop="vip_group_settlement_duration"
          >
            <el-input
              v-model="form.vip_group_settlement_duration"
              placeholder="请输入正整数"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="结算转可提现时长（天）"
            prop="settlement_transfer_withdrawn_duration"
          >
            <el-input
              v-model="form.settlement_transfer_withdrawn_duration"
              placeholder="请输入正整数"
            ></el-input>
          </el-form-item>
          <h3>RP积分设置</h3>
          <el-form-item
            label="零售单品结算时长（天）"
            prop="rp_settlement_duration"
          >
            <el-input
              v-model="form.rp_settlement_duration"
              placeholder="请输入正整数"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-row type="flex" justify="center">
              <!-- <el-button> 返回 </el-button> -->
              <el-button
                type="primary"
                @click="saveConfigs"
                :loading="btnLoading"
                >提交</el-button
              >
            </el-row>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      options: [
        {
          value: '选项1',
          label: '非会员',
        },
        {
          value: '选项2',
          label: '网红',
        },
        {
          value: '选项3',
          label: '套餐A',
        },
        {
          value: '选项4',
          label: '套餐B',
        },
      ],
      btnLoading: false,
      rules: {
        retail_item_settlement_time: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
        vip_group_settlement_duration: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
        settlement_transfer_withdrawn_duration: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
        rp_settlement_duration: [
          { required: true, message: '请填写', trigger: 'change' },
        ],
      },
      form: {
        retail_item_settlement_time: '',
        vip_group_settlement_duration: '',
        settlement_transfer_withdrawn_duration: '',
        rp_settlement_duration: '',
      },
    }
  },
  mounted() {
    this.configs()
  },
  methods: {
    configs() {
      request({
        url: '/api/backend/rewardConfig/configs',
        method: 'get',
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.form = res.data
        }
      })
    },

    saveConfigs() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.btnLoading = true
          request({
            url: '/api/backend/rewardConfig/saveConfigs',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
  },
}
</script>

<style>
.content {
  padding: 20px;
}
</style>
